<template>
  <div>
    <div
      style="min-height: 100vh"
      class="flex w-full bg-img vx-row no-gutter items-center justify-center"
      id="page-login"
    >
      <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-4/5 sm:m-0 m-4">
        <vx-card
          class="my-12"
          style="border-radius: 0.5rem !important; overflow: hidden"
        >
          <div slot="no-body" class="full-page-bg-color">
            <div class="vx-row no-gutter justify-center items-center">
              <div class="vx-col sm:w-full md:w-full min-h-screen lg:w-1/2">
                <div style="position: relative" class="h-full min-h-screen">
                  <vx-card
                    class="w-3/4 bg-dark"
                    style="
                      overflow: hidden;
                      position: absolute;
                      left: 50%;
                      top: 50%;
                      transform: translate(-50%, -50%);
                      min-height: 400px;
                    "
                  >
                    <div id="logo-badge">
                      <div class="d-flex align-items-center h-full px-1">
                        <!-- <LogoRed class="w-full" /> -->
                        <img
                          v-if="!!form && !!form.logo"
                          :src="form.logo"
                          class="w-full"
                          alt=""
                        />
                      </div>
                    </div>
                    <div
                      class="text-white"
                      style="position: relative; padding-left: 75px; top: -15px"
                    >
                      {{ form.name }}
                    </div>
                    <div id="card-bg" class="w-full h-full"></div>
                  </vx-card>
                  <!-- <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto" /> -->
                </div>
              </div>

              <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                <div slot="no-body" class="">
                  <div class="p-4">
                    <LogoRed
                      class="w-32 mt-1 mb-1 mr-0 fill-current text-primary"
                    />
                    <h1>
                      <span> Create Seller</span>
                      <span> 🚀 </span>
                    </h1>
                    <div style="font-size: 0.75rem; color: #aaa">
                      Get started by create Seller Organize
                    </div>
                    <br />
                    <div>
                      <div>
                        <img
                          v-if="form.logo != null && form.logo != ''"
                          :src="form.logo"
                          :width="imageWidth"
                          :height="imageHeight"
                        />
                        <div
                          v-if="!form.logo"
                          class="default-upload"
                          style="
                            width: 300px;
                            height: 158px;
                            background-color: #f5f5f5;
                            border-radius: 8px;
                            position: relative;
                          "
                        >
                          <vs-button
                            style="
                              position: absolute;
                              top: 50%;
                              left: 50%;
                              transform: translate(-50%, -50%);
                            "
                            color="dark"
                            type="border"
                            @click="chooseImage('logo')"
                          >
                            <span>Upload</span>
                          </vs-button>
                        </div>
                      </div>
                      <div
                        class="grid-button-upload"
                        style="
                          margin-top: 8px;
                          display: grid;
                          grid-template-columns: repeat(2, min-content);
                          grid-gap: 10px;
                        "
                      >
                        <!-- secondary / border  >> btn-->
                        <vs-button
                          v-if="form.logo"
                          color="dark"
                          type="border"
                          icon="autorenew"
                          style="display: flex"
                          @click="chooseImage('logo')"
                        >
                          <span>Change</span>
                        </vs-button>
                        <input
                          style="
                            visibility: hidden;
                            position: flex;
                            left: -500%;
                            height: 0;
                          "
                          id="file-upload-img"
                          @change="onUploadImages('logo')"
                          type="file"
                          ref="fileImage"
                          :accept="acceptFile"
                        />
                        <vs-button
                          v-if="form.logo"
                          color="dark"
                          type="border"
                          icon="delete_forever"
                          style="display: flex"
                          @click="removeposter('logo')"
                        >
                          Remove
                        </vs-button>
                      </div>
                      <!-- <vs-upload
                                    :multiple="false"
                                    :automatic="true"
                                    :single-upload="true"
                                    :fileName="`logo`"
                                    :limit="1"
                                    @change="successPosterUpload"
                                    @on-delete="deleteFileLogo"
                                    accept="image/png, image/jpeg, image/jpg, image/webp"
                                /> -->
                      <vs-input
                        v-validate="{ required: true }"
                        name="logo"
                        class="w-full"
                        v-model="form.logo"
                        style="display: none"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('logo')"
                      >
                        The field is required
                      </span>
                    </div>
                    <br />
                    <div>
                      <div style="font-size: 0.7rem">Organize Name</div>
                      <div>
                        <vs-input
                          v-validate="{
                            required: true,
                          }"
                          name="name"
                          class="w-full"
                          v-model="form.name"
                          :maxLength="60"
                        />
                        <span
                          class="text-danger text-sm"
                          v-show="errors.has('name')"
                        >
                          {{ errors.first("name") }}
                        </span>
                      </div>
                    </div>
                    <br />
                    <div>
                      <div style="font-size: 0.7rem">Username</div>
                      <div style="font-size: 0.7rem; color: #aaa">
                        https://{{ form.slug }}.soldoutt.com
                      </div>
                      <div>
                        <vs-input
                          name="slug"
                          class="w-full"
                          v-model="form.slug"
                          v-on:keyup="validateSlug()"
                        />
                        <span
                          class="text-danger text-sm"
                          v-show="errors.has('slug')"
                        >
                          {{ splitError(errors.first("slug"), "slug") }}
                        </span>
                      </div>
                    </div>
                    <br />
                    <div>
                      <div style="font-size: 0.7rem">Time Zone</div>
                      <div>
                        <el-select
                          v-validate="'required'"
                          style="width: 100%"
                          v-model="form.timezone"
                          filterable
                          placeholder="Select timezone"
                        >
                          <el-option
                            v-for="item in timezones"
                            :key="item.key"
                            :label="item.value"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                        <span
                          class="text-danger text-sm"
                          v-show="errors.has('timezone')"
                        >
                          {{ errors.first("Time Zone") }}
                        </span>
                      </div>
                    </div>
                    <br />
                    <div>
                      <div style="font-size: 0.7rem">Contact Phone</div>
                      <div>
                        <vs-input
                          class="w-full"
                          v-model="form.phone"
                          onkeypress="return /^[-+0-9]/i.test(event.key)"
                          onpaste="return false"
                        />
                      </div>
                    </div>
                    <br />
                    <div class="text-right">
                      <vs-button
                        @click="validateForm"
                        small
                        class="mt-6 ml-auto"
                        >Submit</vs-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </vx-card>

        <!-- <div>Mode : {{ mode }}</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import Service from "../../../services";
import LogoRed from "../../../layouts/components/LogoRed.vue";
import FBBtn from "../../../layouts/components/FBBtn.vue";
import GoogleBtn from "../../../layouts/components/GoogleBtn.vue";
import { eventFieldsPermission } from "@/utils/FieldsPermission";
import { timezones } from "@/utils/Timezones";

export default {
  components: { LogoRed, FBBtn, GoogleBtn },
  data() {
    return {
      imageHeight: 0,
      imageWidth: 0,
      popupActivo: false,
      checkbox_remember_me: false,
      mode: "Development",

      eventFieldsPermission: eventFieldsPermission,
      posterUploadUrl:
        process.env.VUE_APP_API_URL +
        "/events/" +
        this.$route.query.e +
        "/merchant/upload",
      posterUploadHeader: {
        Authorization:
          "Bearer " +
          JSON.parse(localStorage.getItem("soldoutt-nimda")).Auth.accessToken,
      },
      form: {
        logo: "",
        name: "",
        domain: "",
        folder: "",
        timezone: "Asia/Bangkok",
        emailfromname: "",
        emailfromemail: "",
        smssender: "",
        fbpage: "",
        lineid: "",
        txtcolor: "",
        bgcolor: "",
        bgimg: "",
        font: "",
        bank1: "",
        bankaccname1: "",
        bankaccno1: "",
        bank2: "",
        bankaccname2: "",
        bankaccno2: "",
        gtmid: "",
        gaid: "",
        fbpid: "",
        awcid: "",
        awclabel: "",
        phone: "",
        email: "",
        contactperson: "",
      },
      suckerArea: [],
      suckerCanvas: null,
      posterData: {
        type: "poster",
      },
      bgImgData: {
        type: "bgimg",
      },
      timezones: timezones,
      fontList: [],
      logo: "",
      bankList: [
        {
          name: "Kasikorn Bank",
          code: "kbank",
        },
        {
          name: "Siam Commercial Bank",
          code: "scb",
        },
        {
          name: "Krungthai Bank",
          code: "ktb",
        },
        {
          name: "Bank of Ayudhya",
          code: "bay",
        },
        {
          name: "Bangkok Bank",
          code: "bbl",
        },
      ],
      role: "user",
      acceptFile: ["image/png", "image/jpeg", "image/jpg", "image/webp"],
      logoUpdate: null,
      bgUpdate: null,
    };
  },
  created() {
    if (process.env.VUE_APP_ENV != "development") {
      this.mode = "Production";
    }
    this.timezones = Object.keys(this.timezones).map((item) => {
      return { key: item, value: item };
    });
  },
  mounted() {
    this.setImageSize();
    if (localStorage.getItem("onboarding-form")) {
      this.form = JSON.parse(localStorage.getItem("onboarding-form"));
    }
  },
  methods: {
    validateSlug() {
      var slugify = require("slugify");
      this.form.slug = slugify(this.form.slug, {
        replacement: "-", // replace spaces with replacement character, defaults to `-`
        remove:
          /[*#+~%^&*.()๋ัฤ็ฺ๋?ฦ๐ํ๊ฯ,ๆำๅกขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรลวศษสอหฬฮะาิีุูึ์ ืแโใไ๑๒๓๔ู฿๕๖๗๘๙่เ้'"!:@=]/g, // remove characters that match regex, defaults to `undefined`
        lower: true, // convert to lower case, defaults to `false`
        strict: false, // strip special characters except replacement, defaults to `false`
      });

      if (this.form.slug.match(/(\w+)/g).length > 5) {
        var words = this.form.slug.split("-");
        this.form.slug =
          words[0] +
          "-" +
          words[1] +
          "-" +
          words[2] +
          "-" +
          words[3] +
          "-" +
          words[4];
      }
    },
    validateForm() {
      // this.form.folder = this.s;

      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
          this.submit();
        } else {
          // form have errors
        }
      });
    },
    submit() {
      // this.$vs.loading();
      const formData = new FormData();
      const dataKeyForms = Object.keys(this.form);
      for (let index = 0; index < dataKeyForms.length; index++) {
        const key = dataKeyForms[index];
        const value = this.form[key];
        formData.append(key, value);
      }
      formData.set("logo", this.logoUpdate);
      formData.set("bgimg", this.bgUpdate);

      // Service.Merchant.create(formData, this.s)
      //   .then((res) => {
      //     // console.log(res, 'create')
      //     this.$vs.notify({
      //       title: "Success",
      //       text: "Update complete.",
      //       color: "success",
      //     });
      //     // this.$router.push("/sellers?s=" + this.s + "&e=" + this.e);
      //     this.$router.push("/onboarding/create-event/" + res.data.merchant_id);

      //     this.$vs.loading.close();
      //   })
      //   .catch((err) => {
      //     this.$vs.notify({
      //       title: "Oops!",
      //       text: "ERROR : " + err.error,
      //       color: "danger",
      //     });
      //     this.$vs.loading.close();
      //   });
      this.$vs.notify({
        title: "Success",
        text: "Update complete.",
        color: "success",
      });
      // this.$router.push("/sellers?s=" + this.s + "&e=" + this.e);
      const formString = JSON.stringify(this.form);
      localStorage.setItem("onboarding-form", formString);
      this.$router.push(
        "/onboarding/create-event/mock"
        // + res.data.merchant_id
      );

      this.$vs.loading.close();
    },
    cancel() {
      this.$router.push("/sellers?s=" + this.s + "&e=" + this.e);
    },
    removeposter(val) {
      if (val === "logo") {
        this.form.logo = null;
      } else {
        this.form.bgimg = null;
      }
    },
    chooseImage(val) {
      if (val === "logo") {
        document.getElementById("file-upload-img").click();
      } else {
        document.getElementById("file-upload-bg").click();
      }
    },
    onUploadImages(val) {
      if (val === "logo") {
        this.form.logo = this.$refs.fileImage.files[0];
        this.logoUpdate = this.$refs.fileImage.files[0];
        const reader = new FileReader();
        reader.onloadend = async () => {
          this.form.logo = reader.result;
          // this.posterUpdate = reader.result
          this.setImageSize();
        };
        reader.readAsDataURL(this.$refs.fileImage.files[0]);
        this.$refs.fileImage.value = null;
      } else {
        this.form.bgimg = this.$refs.fileBg.files[0];
        this.bgUpdate = this.$refs.fileBg.files[0];
        const reader = new FileReader();
        reader.onloadend = async () => {
          this.form.bgimg = reader.result;
          // this.posterUpdate = reader.result
          this.setImageSize();
        };
        reader.readAsDataURL(this.$refs.fileBg.files[0]);
        this.$refs.fileBg.value = null;
      }
    },
    setImageSize() {
      let posterimage = document.querySelector("img");
      let w = posterimage.naturalWidth;
      let h = posterimage.naturalHeight;
      this.imageHeight = h;
      this.imageWidth = w;

      if (w > h) {
        this.imageWidth = 300;
        this.imageHeight = "auto";
      } else {
        this.imageHeight = 300;
        this.imageWidth = "auto";
      }
    },
    splitError(val, word) {
      if (!val) {
        return;
      } else {
        const data = val.split(word);
        return data[0] + data[1];
      }
    },
  },
};

function getParamFromLink(data) {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get(data);
}
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }

    .bg-twitter {
      background-color: #00aaff;
    }

    .bg-google {
      background-color: #4285f4;
    }

    .bg-github {
      background-color: #333;
    }
  }
}
#card-bg {
  position: absolute;
  left: 0%;
  top: 30px;
  background: linear-gradient(180deg, #013562 0%, #000 30%);
  min-height: 800px;
}
#logo-badge {
  position: absolute;
  left: 15px;
  top: 0;
  width: 70px;
  height: 40px;
  background: #fff;
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  z-index: 2;
}
</style>
